'use strict';

(function () {
	angular.module('onboarding.services')
		.factory('sessionService', sessionService);


	sessionService.$inject = [
		'subjectObserverMessagesService', 'observerService', '$http', '$log', '$state',
		'$stateParams', '$window', '$rootScope', 'usurpService'
	];

	function sessionService(subjectObserverMessagesService,
		observerService,
		$http,
		$log,
		$state,
		$stateParams,
		$window,
		$rootScope,
		usurpService) {
		var _userName = null;
		var _capabilities = null;
		var _allowedLogins = null;
		var _carrierNavState = null;
		var _domain = null;
		var _broker = null;
		var _carrierReadyToSign = false;
		var _usurpEnabled = false;

		return {
			create: create,
			destroy: destroy,
			getUserName: getUserName,
			getCapabilities: getCapabilities,
			setBrokerImpersonated: setBrokerImpersonated,
			getBrokerImpersonated: getBrokerImpersonated,
			setCarrierImpersonated: setCarrierImpersonated,
			getCarrierImpersonated: getCarrierImpersonated,
			getDomain: getDomain,
			setDomain: setDomain,
			getAllowedLogins: getAllowedLogins,
			setAllowedLogins: setAllowedLogins,
			clearDomain: clearDomain,
			saveCarrierVisit: saveCarrierVisit,
			getBrokerLogoURL: getBrokerLogoURL,
			getBrokerBranding: getBrokerBranding,
			setBrokerBranding: setBrokerBranding,
			clearBrokerBranding: clearBrokerBranding,
			setCarrierReadyToSign: setCarrierReadyToSign,
			getCarrierReadyToSign: getCarrierReadyToSign,
			getCarrierNavState: getCarrierNavState,
			setCarrierNavState: setCarrierNavState,
			restoreState: restoreState,
			isAuthorized: isAuthorized,
			isAuthorizedBrokerAdmin: isAuthorizedBrokerAdmin,
			isAuthorizedBrokerRead: isAuthorizedBrokerRead,
			isAuthorizedBrokerWrite: isAuthorizedBrokerWrite,
			isAuthorizedInternalAdmin: isAuthorizedInternalAdmin,
			isAuthorizedCarrierRead: isAuthorizedCarrierRead,
			isAuthorizedCarrierWrite: isAuthorizedCarrierWrite,
			isAuthorizedCarrierSign: isAuthorizedCarrierSign,
			isAuthorizedCarrierAdmin: isAuthorizedCarrierAdmin,
			getCarouselViewed: getCarouselViewed,
			setCarouselViewed: setCarouselViewed,
			getApplicationSettings: getApplicationSettings,
			getLastVisitedPage: getLastVisitedPage,
			setLastVisitedPage: setLastVisitedPage,
			removeLastVisitedPage: removeLastVisitedPage,
			redirectToLogin: redirectToLogin,
			//is admin impersonating or in role
			isBroker: isBroker,
			isCarrier: isCarrier,
			getBrokerByDomainName: getBrokerByDomainName,
			setUsurpEnabled: setUsurpEnabled,
			isUsurpEnabled: isUsurpEnabled
		};

		function create(data) {
			if (data) {
				setUserName(data.userName);
				setCapabilities(data.capabilities);
				setAllowedLogins(data.allowedLoginTypes);
				setUsurpEnabled();
			}
			
			saveState();
		}

		function destroy() {
			setUserName(null);
			setCapabilities(null);

			usurpService.removeUsurpLSKey();
			localStorage.removeItem('session.userName');
			localStorage.removeItem('session.capabilities');
		}

		function setBrokerImpersonated(brokerId, name, domain) {
			if (isAuthorizedInternalAdmin()) {
				var brokerImpersonated = {
					brokerId: brokerId,
					name: name,
					domain: domain
				};

				localStorage.setItem('brokerImpersonated' + brokerId, angular.toJson(brokerImpersonated));
			}
		}

		function getBrokerImpersonated() {
			if ($stateParams.brokerId) {
				return angular.fromJson(localStorage.getItem('brokerImpersonated' + $stateParams.brokerId));
			} else
				return {};
		}

		function setCarrierImpersonated(carrierId,
			carrierName,
			dotNumber,
			intrastateCode,
			intrastateState) {

			var carrierImpersonated = {
				carrierId: carrierId,
				carrierName: carrierName,
				dotNumber: dotNumber,
				intrastateState: intrastateState,
				intrastateCode: intrastateCode,
				intrastateNumber: intrastateCode
			};

			localStorage.setItem('carrierImpersonated' + carrierId, angular.toJson(carrierImpersonated));
		}

		function getCarrierImpersonated() {
			if ($stateParams.carrierId) {
				var carrierImpersonated = angular.fromJson(localStorage
					.getItem('carrierImpersonated' + $stateParams.carrierId));
				if (!carrierImpersonated)
					return {};

				return carrierImpersonated;
			}

			return {};
		}

		function setUserName(name) {
			_userName = name;
		}

		function getUserName() {
			return _userName;
		}

		function setCapabilities(capabilities) {
			_capabilities = capabilities;
		}

		function getCapabilities() {
			return _capabilities;
		}

		function setAllowedLogins(allowedLogins) {
			_allowedLogins = allowedLogins;
		}

		function getAllowedLogins() {
			return _allowedLogins;
		}

		function getDomain() {
			return _domain;
		}

		function setDomain(domain, scope) {
			$http
				.get('/api/brokerLookup/brokerLandingPage', { params: { domain: domain } })
				.then(function (response) {
					setBrokerBranding(response.data);
					_domain = domain;
					observerService.sendMessageToSubject(scope,
						subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_DOMAIN_DATA_LOADED);
					saveCarrierVisit();
				})
				.catch(function (e) {
					$log.error(e);
				});
		}

		function clearDomain() {
			_domain = null;
			clearBrokerBranding();
		}

		function saveCarrierVisit() {
			if (_broker && isAuthorizedCarrierRead()) {
				var request = {
					brokerId: _broker.brokerId
				};

				$http.post('/api/carrierregistration/registerCarrierVisit', request);
			}
		}

		function getBrokerBranding() {
			return _broker;
		}

		function getBrokerLogoURL() {
			if (_broker.imageMimeType) {
				return 'data:' + _broker.imageMimeType + ';base64,' + _broker.imageFile;
			}
		}

		function setBrokerBranding(broker) {
			_broker = broker;
		}

		function clearBrokerBranding() {
			_broker = null;
		}

		function setCarrierReadyToSign(isReady) {
			_carrierReadyToSign = isReady;
		}

		function getCarrierReadyToSign() {
			return _carrierReadyToSign;
		}

		function saveState() {
			localStorage.setItem('session.userName', angular.toJson(_userName));
			localStorage.setItem('session.capabilities', angular.toJson(_capabilities));
		}

		function restoreState() {
			_userName = angular.fromJson(localStorage.getItem('session.userName'));
			_capabilities = angular.fromJson(localStorage.getItem('session.capabilities'));
		}

		function isAuthorized(capability) {
			if (_capabilities === null)
				return false;

			return (_userName !== '') && (_capabilities.indexOf(capability) !== -1);
		}

		function isAuthorizedInternalAdmin() {
			if (isAuthorized('InternalAdmin') || isAuthorized('InternalAccount'))
				return true;
			else
				return false;
		}

		function isAuthorizedBrokerAdmin() {
			if (isAuthorized('BrokerAdmin') || ($stateParams.brokerId && isAuthorizedInternalAdmin()))
				return true;

			return false;
		}

		function isAuthorizedBrokerRead() {
			if (isAuthorized('BrokerRead') || ($stateParams.brokerId && isAuthorizedInternalAdmin()))
				return true;

			return false;
		}

		function isAuthorizedBrokerWrite() {
			if (isAuthorized('BrokerWrite') || ($stateParams.brokerId && isAuthorizedInternalAdmin()))
				return true;

			return false;
		}

		function isAuthorizedCarrierRead() {
			if (isAuthorized('CarrierRead'))
				return true;

			return false;
		}

		function isAuthorizedCarrierWrite() {
			if (isAuthorized('CarrierWrite'))
				return true;

			return false;
		}

		function isAuthorizedCarrierSign() {
			if (isAuthorized('CarrierSign'))
				return true;

			return false;
		}

		function isAuthorizedCarrierAdmin() {
			if (isAuthorized('CarrierAdmin'))
				return true;

			return false;
		}

		function isBroker() {
			return isAuthorizedBrokerRead() ||
			(isAuthorizedInternalAdmin() && $stateParams.brokerId);
		}

		function isCarrier() {
			return isAuthorizedCarrierRead() ||
			(isAuthorizedInternalAdmin() && $stateParams.carrierId && !$stateParams.brokerId
			);
		}

		function isUsurpEnabled(){
			return _usurpEnabled;
		}

		function getCarrierNavState() {
			return _carrierNavState;
		}

		function setCarrierNavState(carrierNavState) {
			return _carrierNavState = carrierNavState;
		}

		function getCarouselViewed() {
			return localStorage.getItem('carouselViewed');
		}

		function setCarouselViewed() {
			localStorage.setItem('carouselViewed', true);
		}

		function getApplicationSettings() {
			return $http.get('/api/application/settings').then(
				function (response) {
					return response.data;
				});
		}

		function setUsurpEnabled() {
			getApplicationSettings()
				.then(function (response) {
					_usurpEnabled = response.usurpEnabled;
				});
		}

		function setLastVisitedPage(options) {
			localStorage.setItem('lastVisitedPageKey', angular.toJson({
				name: options ? options.name : $state.current.name,
				params: options ?  options.params : $state.params,
				capabilities: getCapabilities()
			}));
		}

		function getLastVisitedPage() {
			return angular.fromJson(localStorage.getItem('lastVisitedPageKey'));
		}

		function removeLastVisitedPage() {
			localStorage.removeItem('lastVisitedPageKey');
		}

		function redirectToLogin() {
			$window.location.href = $window.location.origin + '/logout'; 
		}

		function getBrokerByDomainName(broker) {
			return $http.get('/api/brokerLookup/brokerLandingPage?domain=' + broker);
		}
	}
})();
